const Fungicides = [
    {
        _id:"1",
        name:"ANTRAGOL",
        image:"/images/Fungicides/1.png",
        Title:"(Propineb 70% WP)",
        description: "It is a contact fungicide based on probineb techincal containing 70% w/w propineb as active ingredient. Propineb is used as a foliar spray for the control of fungal diseases in different crops. Antragol contact fungicide with broad spectrum activity against various diseases of rice, chilli, grapes, potato and other vegetables and fruits. Propineb is a polymeric zinc-containing dithiocarbamate. Due to the release of zinc, the application of Incheck results in greening effect on the crop and subsequent improvement in quality of produce."
    },
    {
        _id:"2",
        name:"BACKBONE",
        image:"/images/Fungicides/2.png",
        Title:"(Carbendazim 12% + Mancozeb 63% WP)",
        description: `It is a systemic and contact fungicide used for seed treatment for the effective control of tikka
        leaf spot, collar rot and dry root rot diseases of Groundnut, Blast on Paddy, Early blight, Late blight,
        black scruf on Potato, Blister blight, Grey blight, Red rust, Dieback, Black rot on Tea, Downey mildew,
        Powdery mildew & Anthracnose on Grape, Powdery mildew & Anthracnose on Mango, Leaf spot, fruit
        rot and Powdery mildew on Chilli, Downey mildew & leaf blight on Maize, Fruit scab & Powdery mildew on Apple and Tikka leaf spot, Collar rot and Dry root rot on Groundnut.
        `
    },
    
    {
        _id:"3",
        name:"BLUEBONE",
        image:"/images/Fungicides/3.png",
        Title:"(Copper Oxychloride 50% WP)",
        description: `It is a safe and soluble powder used as fungicide to control many fungal diseases such as Scab,
        Anthracnose, Anthracnose, Downy mildew, Early and Late blight , Leaf spot diseases in a wide range
        of field crops, fruits, nuts, vegetables, ornamentals etc viz Ground nut, Paddy, Potatoes, Tomatoes,
        vines, cucurbits, Apples, Bananas, citrus etc. in accordance with the climatic conditions and local
        authorities.
        Time of Application
        For the best results apply prophyllatically i.e. before disease attack plants,in rain weather spraying
        must be repeated at shorter intervals.
        
        `
    },
    
    {
        _id:"4",
        name:"Bonetin",
        image:"/images/Fungicides/4.png",
        Title:"",
        description: `It is a systemic fungicide with protective and curative action. It is absorbed through the roots and green tissues. It acts by inhibiting beta-tubulin synthesis, Inhibiting development of germ tubes and the growth of mycelia. It is compatible with most of the insecticides. It is used for the control of blast, Seath blight, Brown spot, Powdery mildew, Scab, Anthracnose and leaf sopt disease in various crops. It inhibits the development of the germs tubes, The formation of appressoria and the growth of mycelia.

        `
    },
    {
        _id:"5",
        name:"DOUBLE GROWTH",
        image:"/images/Fungicides/5.png",
        Title:"(Tebuconazole 10% + Sulphur 65% WG)",
        description: `It is a (water dispersible granule) effective fungicide fungicide with protective, creative and eradicative
        action. It controls powdery mildew, fruit rot diseases of Chilli and leaf spot, pod blight disease of
        Soybean. Tebuconazole works as steroid demethylation (ergosterol biosynthesis) inhibitor. It rapidly
        absorbed into the vegetative parts of the plant, with translocation principally acropetally. Sulphur is
        non-systemic protective fungicide with contact and vapour action, shows secondary acaricidal activity.
        It is applied with knapsack sprayer at early appearance of disease. For reasons of phytotoxicity,
        mixing with oils should be avoided. It is used to control scab on apple pear and other vegetables life
        chilli and soyabean. WDG ( Water Dispersible Granule) is a effective fungicide with protective,
        creative and eradicative action. It controls powdery mildew, fruit rot diseases of chili and leaf spot,
        pod blight diseases of soybean.
        `
    },
    {
        _id:"6",
        name:"GALAXY 35",
        image:"/images/Fungicides/6.png",
        Title:"(Metalaxyl 35% WS)",
        description: `It is a highly active and systemic fungicide based on the active ingredient, metalaxyl. It contains 350
        g. active ingredient per kg. of the product. It is used as a wet slurry seed dresser. is a systemic
        fungicide with a protective and curative action, absorbed through the leaves, stems and roots to
        control diseases caused by air and soil borne fungus i.e Scab, Anthracnose, Anthracnose, Downy
        mildew,Early blight, and Late blight diseases of various crops like Maize, Bajra, Sorghum, Sunflower,
        Mustard, Sugarcane, Potatoes, Tomatoes, Vines, Peppers, tobacco etc in accordance with the
        climatic conditions and local authorites.
        `
    },
    
    {
        _id:"7",
        name:"GPM-45",
        image:"/images/Fungicides/7.png",
        Title:"(Mancozeb 75% WP)",
        description: `It is used to control brown and black rust & blight of wheat, leaf blight & downy mildew of maize blast
        of paddy, leaf spot of sorghym. Tip rot, Sigatoka leaf spot and cigar end rot of banana and other
        
        Ground nut: to treat the seed, first make slurry with required quantity of test fungicide with 10 ml of
        water per 1 kg of seed and swirl it in a closed container to make uniform coating on the seeds. Then
        shade dry and sown.
        
        Time of Application:
        Mainly foliar spray and also soil drench. Knapsack sprayer, foot sprayer, compression knapsack
        sprayer, compression knapsack battery sprayer, ASPEE-HIP power sprayer.
        fungal disease of guava potato, tomato, apple, grapes, chilli, cauliflowers, groundnut and cumin
        crops.
        `
    },
    {
        _id:"8",
        name:"HUMSAFAR",
        image:"/images/Fungicides/8.png",
        Title:"(Hexaconazole 5% SC)",
        description: `is a highly effective systemic Fungicide with a protective and curative action to control different kind
        of fungi Detailed Description (HEXACONAZOLE 5% SC) is useful to Control of many fungi,
        particularly Ascomycetes and Basidiomycetes, e.g Podosphaera leucotricha and Venturia inaequalis
        on apples, Guignardia bidwellii and Uncinula necator on vines, Hemileia vastatrix on coffee, and
        Cercospora spp. on peanuts. Also used on bananas, cucurbits, peppers, apples, Rice, Groundnut,
        Mango and other crop in accordance with the climatic conditions and Local Authorities.
        `
    },
    {
        _id:"9",
        name:"HUMSAFAR - G75",
        image:"/images/Fungicides/9.png",
        Title:"(Hexaconazole 75% WG)",
        description: `It is a systematic fungicide used for the control of sheath blight and sheath rot on paddy.
         
        1) Preparation of spray solution :- Take the required quantity of formulation dilute with little water and
        stair well using a stick. Then add the remaining quantity of water as per spray volume required and
        mix well again by stirring.
        
        2) Plant protection equipment:- Use knapsack sprayer, foot sprayer, compression knapsack sprayer,
        compression knapsack battery sprayer of ASPEE-HTP sprayer.
        
        3) Compatibility :- Hexaconazole 75% WG is compatible with most of the commonly used insecticides
        and fungicides.
        
        4) Phytotoxicity:- Hexaconazol 75% WG is not phytotoxic when used as per recommendations.
        Not to be used for post harvest application.`
    },
   {
        _id:"10",
        name:"INJECT",
        image:"/images/Fungicides/10.png",
        Title:"(Myclobutanil 10 % WP)",
        description: `It is a systemic fungicide containing Myclobutanil active ingredients. It is effecitive wettable powder
        formulation economically controlling important dieseases powdery mildew on Grapes, scab of Apple
        and Powdery mildew, Leaf spot, die back of Chillies.`
    } ,
   {
        _id:"11",
        name:"LIFE LINE",
        image:"/images/Fungicides/11.png",
        Title:"(Validamycin 3% L)",
        description: `It is an antifungal preparation and antibiotic compound. It controls Sheath blight disease of Rice very
        effectively. It acts on hyphae and destroys the fungus by its contact action and controls the spread of
        diseases. Sukhiya VIPis most effective against soil borne diseases and used for the control
        Rhizoctonia Solani in rice, potato, vegetables and other crops and also damping off disease of many
        crops. Itremains effective for a long time even after rain. Itis compatible with all the generally used
        insecticides and fungicides.
        `
    },
   {
        _id:"12",
        name:"RIPPLE-XRP",
        image:"/images/Fungicides/12.png",
        Title:"Difenoconazole 25% EC",
        description: `It is a systemic fungicide with excellent action against diseases such as Apple scab, sheath blight in
        paddy and die back and fruit rot in chilli crop, Anthracnose, Powdery mildew in grapes and fruit rot in
        Pomegranate . It contains 250 gm Difenoconazole 1-{2-[4-(4- clorophenoxy) -2-chlorpheny]-4-methyl-
        1-3- dioxolan 2-y1methyl}-1,2,4 trazole. per kg of emulsifiable concentrate (EC) formulation.
                
        `
    },

    
]
export default Fungicides